import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "aiSpeachCreatorContainer"
};
const _hoisted_2 = {
  class: "titleText"
};
const _hoisted_3 = {
  class: "subtitleText"
};
const _hoisted_4 = {
  key: 0,
  class: "uploadParamsLayout"
};
const _hoisted_5 = {
  class: "uploadStep"
};
const _hoisted_6 = {
  class: "uploadImportPlaceholder"
};
const _hoisted_7 = {
  class: "uploadImportPlaceholderFile"
};
const _hoisted_8 = {
  class: "fileName"
};
const _hoisted_9 = {
  class: "fileProgress"
};
const _hoisted_10 = {
  class: "iconCheck"
};
const _hoisted_11 = {
  class: "optionButton"
};
const _hoisted_12 = {
  key: 1,
  class: "buttonBottomLine"
};
const _hoisted_13 = {
  key: 2,
  class: "stepsGeneratorStep"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_loader = _resolveComponent("loader");
  const _component_AISpeachGeneratorPanelOption = _resolveComponent("AISpeachGeneratorPanelOption");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_AIStepsGenerator = _resolveComponent("AIStepsGenerator");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('aiSpeachGenerator.title')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('aiSpeachGenerator.subtitle')), 1), _ctx.step === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_upload, {
    class: "uploadElementAI",
    drag: "",
    disabled: _ctx.uploadInProgress,
    multiple: "",
    "show-file-list": false,
    "file-list": _ctx.listOfUserFile,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => _ctx.listOfUserFile = $event),
    "auto-upload": false,
    accept: ".pdf,.doc,.docx,.xls,.xlsx,.xlsm,.ppt,.pptx,.odt,.ods,.odp,.rtf,.csv,.txt,.xml,.html,.md,.key,.pages",
    onChange: _ctx.onFileChange
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_icon, {
      icon: "upload-outline",
      size: "large",
      color: "light1"
    }), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('aiSpeachGenerator.upload.placeholder')), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('aiSpeachGenerator.upload.file')), 1)])]),
    _: 1
  }, 8, ["disabled", "file-list", "onChange"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proceededFile, file => {
    return _openBlock(), _createElementBlock("div", {
      class: "fileElement",
      key: file.uid
    }, [_createElementVNode("div", _hoisted_8, _toDisplayString(file.name), 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_progress, {
      percentage: file.progress > 0 ? file.progress : 10,
      "show-text": false,
      indeterminate: file.progress === 0,
      duration: 1
    }, null, 8, ["percentage", "indeterminate"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_Transition, {
      name: "fade"
    }, {
      default: _withCtx(() => [_withDirectives(_createVNode(_component_icon, {
        icon: "check-circle",
        color: "success",
        size: "default"
      }, null, 512), [[_vShow, file.data.length > 0]])]),
      _: 2
    }, 1024), _createVNode(_Transition, {
      name: "fade"
    }, {
      default: _withCtx(() => [_withDirectives(_createVNode(_component_icon, {
        icon: "close-octagon-outline",
        color: "danger",
        size: "default"
      }, null, 512), [[_vShow, file.progress == -1]])]),
      _: 2
    }, 1024), _createVNode(_Transition, {
      name: "fade"
    }, {
      default: _withCtx(() => [_withDirectives(_createVNode(_component_loader, {
        "spinner-size": "spinnersSmall"
      }, null, 512), [[_vShow, file.data.length <= 0 && file.progress >= 0]])]),
      _: 2
    }, 1024)])]);
  }), 128))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.showOption = !_ctx.showOption)
  }, [_createVNode(_component_icon, {
    icon: !_ctx.showOption ? 'chevron-down' : 'chevron-up'
  }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.options.button')), 1)])]), _createVNode(_Transition, {
    name: "slideDown",
    "enter-active-class": "fadeInUp",
    "leave-active-class": "fadeOut",
    class: "paramsOption"
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_AISpeachGeneratorPanelOption, {
      onDurationChange: _ctx.onDurationChange,
      onAllowReorder: _ctx.onAllowReorder,
      onLanguageChange: _ctx.onLanguageChange,
      onSpecificPrompt: _ctx.onSpecificPromptChange
    }, null, 8, ["onDurationChange", "onAllowReorder", "onLanguageChange", "onSpecificPrompt"]), [[_vShow, _ctx.showOption]])]),
    _: 1
  })])) : _createCommentVNode("", true), _ctx.step === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_standard_button, {
    class: "uploadDocumentButton",
    disabled: !_ctx.isAllFileProceed,
    onAction: _ctx.validateUploadDocument
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "creation-outline"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.generateButton')), 1)]),
    _: 1
  }, 8, ["disabled", "onAction"])])) : _createCommentVNode("", true), _ctx.step === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_AIStepsGenerator, {
    "ai-files": _ctx.proceededFile,
    "uploaded-files": _ctx.listOfUserFile,
    language: _ctx.languageSelected,
    duration: _ctx.durationSelected,
    specificPrompt: _ctx.specificPrompt,
    allowReorder: _ctx.allowReorder,
    "weet-endpoint": _ctx.weetEndpoint
  }, null, 8, ["ai-files", "uploaded-files", "language", "duration", "specificPrompt", "allowReorder", "weet-endpoint"])])) : _createCommentVNode("", true)]);
}